export default class FilesService {
  static $inject = ['$http'];

  baseUrl = '/aptitude/api/files';

  constructor(private $http) {
    'ngInject';
  }

  parseHeaders(fileId: number, headerRows): ng.IPromise<any> {
    return this.$http.post(`${this.baseUrl}/${fileId}/mappedheader`, {
      rows: headerRows
    });
  }

  parseCrossReferenceHeaders(fileId: number, headerRows): ng.IPromise<any> {
    return this.$http.post(`/aptitude/api/uploadrequests/${fileId}/header`, {
      rows: headerRows
    });
  }
}
